import { shortDate } from '../utils/formatters';
import moment from 'moment';

export const _getInitialStartDate = () => {
    const initialStartDate = moment()
        .subtract(3, 'months')
        .toDate();
    initialStartDate.setHours(0);
    initialStartDate.setMinutes(0);
    initialStartDate.setSeconds(0);
    return initialStartDate;
};

export const _getInitialEndDate = () => {
    return moment()
        .subtract(36, 'hours')
        .toDate();
};

export const getFiltersInitialState = () => {
    const initialStartDate = _getInitialStartDate();
    const initialEndDate = _getInitialEndDate();
    return {
        Accounts: {
            title: 'Accounts',
            value: {},
            filterValue: {},
            displayValues: [],
        },
        'Media Type': {
            title: 'Media Type',
            value: {},
            displayValues: [],
        },
        Caption: { title: 'Caption', value: '', displayValues: [] },
        startDate: {
            title: 'From',
            value: initialStartDate,
            displayValues: [shortDate(initialStartDate)],
        },
        endDate: {
            title: 'To',
            value: initialEndDate,
            displayValues: [shortDate(initialEndDate)],
        },
        Campaigns: {
            title: 'Campaigns',
            value: {},
            displayValues: [],
            options: [],
        },
    };
};

export const defaultTotals = {
    engagementsTotal: 0,
    impressionsTotal: 0,
    videoViewsTotal: 0,
    fmvTotal: 0,
};
